import { TRENDS } from '@/mocks/trending';

function Strip() {
  return (
    <div className="flex shrink-0 items-center" aria-hidden="true">
      {TRENDS.slice(0, 8).map((t) => (
        <span key={t.id} className="mx-6 inline-flex items-center gap-2 whitespace-nowrap text-sm text-background-100/90">
          <i className="ri-flashlight-fill text-primary-400" aria-hidden="true"></i>
          <span className="text-background-50">{t.title}</span>
          <span className="text-xs text-background-100/60">{t.heat}</span>
        </span>
      ))}
    </div>
  );
}

export default function Ticker() {
  return (
    <div className="relative overflow-hidden border-y border-primary-900 bg-foreground-950 py-3">
      <span className="absolute left-0 top-0 z-10 inline-flex h-full items-center gap-1.5 bg-primary-500 px-3 text-xs font-bold text-background-50 md:px-4">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50 opacity-75"></span>
          <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50"></span>
        </span>
        <span className="hidden md:inline">实时滚动</span>
      </span>
      <div className="ml-14 flex overflow-hidden md:ml-24">
        <div className="animate-ticker flex shrink-0">
          <Strip />
          <Strip />
        </div>
      </div>
    </div>
  );
}